import { navigateWithTopBar } from '../shared/guarded-navigation.js';
import { handleMemberSpaRequestError } from './member-spa-auth.js';
import { openManualCardModal } from './manual-card-form.js';
import { initUserSavedPaymentEntry } from './user-saved-payment.js';
import { memberRoutes, memberNavigateTo, withMemberCongregationQuery } from './member-nav-config.js';
import { runAjaxCommand, runOverlayNavCommand, touchMemberActivity, syncFullPageBodyClasses } from './member-spa-ajax.js';

function buildSaveDonationAmountUrl(donationAmount, coverSurcharge) {
    let amountUrl = memberRoutes().saveDonationAmount;
    amountUrl = amountUrl.replace(':amt', donationAmount);
    amountUrl = amountUrl.replace(':cover', coverSurcharge);
    return amountUrl;
}

export function openDonationPage() {
    return runAjaxCommand(memberRoutes().donationPage, 'POST').then(function (data) {
        memberNavigateTo(data.page || 'donate');
    });
}

export function backToDonationPage() {
    return runAjaxCommand(memberRoutes().goToDonationPage, 'POST').then(function (data) {
        memberNavigateTo(data.page || 'donate');
    });
}

export function openAmountPage(campaignId) {
    touchMemberActivity();
    let campaignUrl = memberRoutes().saveCampaign;
    campaignUrl = campaignUrl.replace(':id', campaignId);
    return runAjaxCommand(campaignUrl, 'POST').then(function (data) {
        memberNavigateTo(data.page || 'donateAmount');
    });
}

export function backToAmountPage() {
    return runAjaxCommand(memberRoutes().goToAmountPage, 'POST').then(function (data) {
        memberNavigateTo(data.page || 'donateAmount');
    });
}

export function openFreqDurPage(donationAmount, coverSurcharge) {
    touchMemberActivity();
    const cover = coverSurcharge === undefined ? false : coverSurcharge;
    const amountUrl = buildSaveDonationAmountUrl(donationAmount, cover);
    return runAjaxCommand(amountUrl, 'POST').then(function (data) {
        memberNavigateTo(data.page || 'donateFrequency');
    });
}

export function openRecurringPresetAmount(donationAmount, coverSurcharge, frequencyId, duration) {
    touchMemberActivity();
    let amountUrl = buildSaveDonationAmountUrl(donationAmount, coverSurcharge);
    amountUrl += '?recurring_frequency_id=' + encodeURIComponent(frequencyId);
    amountUrl += '&recurring_duration=' + encodeURIComponent(duration);
    return runAjaxCommand(amountUrl, 'POST').then(function (data) {
        memberNavigateTo(data.page || 'donateDetails');
    });
}

export function backToFreqDurPage() {
    return runAjaxCommand(memberRoutes().goToFrequencyDurationPage).then(function (data) {
        memberNavigateTo(data.page || 'donateFrequency');
    });
}

export function openDonorInfoPage(frequencyId, frequencyName, durationId) {
    touchMemberActivity();
    let durFreqUrl = memberRoutes().saveFrequency;
    durFreqUrl = durFreqUrl.replace(':id', frequencyId);
    durFreqUrl = durFreqUrl.replace(':name', frequencyName);
    durFreqUrl = durFreqUrl.replace(':dur_id', durationId);
    return runAjaxCommand(durFreqUrl).then(function (data) {
        memberNavigateTo(data.page || 'donateDetails');
    });
}

export function backToDonorInfoPage() {
    return runAjaxCommand(memberRoutes().donorInformation).then(function (data) {
        memberNavigateTo(data.page || 'donateDetails');
    });
}

export function openPaymentPage() {
    runOverlayNavCommand({
        url: memberRoutes().payment,
        type: 'GET',
        success(data) {
            $('#index_paging').html(data.page_info);
            if (window.matchMedia('(max-width: 767px)').matches) {
                openManualCardModal();
            }
            memberNavigateTo(data.page || 'donatePayment');
        },
    });
}

export function openSavedPaymentPage() {
    navigateWithTopBar({
        forceTopBar: true,
        url: withMemberCongregationQuery(memberRoutes().userSavedPayment),
        type: 'GET',
        success(data) {
            $('#index_paging').html(data);
            initUserSavedPaymentEntry();
            memberNavigateTo('donateSavedCards');
        },
        error: handleMemberSpaRequestError,
    });
}

export function processDonorInfoSubmit(donorName, phone, donorEmail, donorComments, token) {
    runOverlayNavCommand({
        url: memberRoutes().processDonorInformation,
        type: 'POST',
        data: {
            donor_name: donorName,
            donor_email: donorEmail,
            donor_comments: donorComments,
            donor_phone: phone,
            _token: token
        },
        success(data) {
            $('#index_paging').html(data.page_info);
            if (window.matchMedia('(max-width: 767px)').matches) {
                openManualCardModal();
            }
            memberNavigateTo(data.page || 'donatePayment');
        },
    });
}

export function routeCharityDonation(charityId, charityAmount, showModal) {
    const charityDonationUrl = memberRoutes().charityDonation
        .replace('_id_', charityId)
        .replace('_amt_', charityAmount);

    runOverlayNavCommand({
        url: charityDonationUrl,
        type: 'GET',
        success(data) {
            $('#index_paging').html(data.page_info);
            syncFullPageBodyClasses();
            if (showModal === true) {
                $('#manualCardModal').modal('show');
            }
            memberNavigateTo('donateCharity', { charity_id: charityId, charity_amount: charityAmount });
        },
    });
}

export function memberLogOut() {
    window.location.assign(memberRoutes().memberLogout);
}
